import React from 'react'
// import { UilAngleLeft, UilAngleRight, UilAngleDoubleRight, UilAngleDoubleLeft } from '@iconscout/react-unicons'
import { Pagination, TablePagination } from '@mui/material'
import { useNavigate } from 'react-router-dom';

// export default function TablePaginationDemo({ pageChange, misc }) {
export default function TablePaginationDemo({ total = 1, current_page = 1, onPageChange = () => null, onRowsPerPageChange = () => null, per_page = 10 }) {
  const [page, setPage] = React.useState(current_page);
  const [rowsPerPage, setRowsPerPage] = React.useState(per_page);
  const navigate = useNavigate()
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    onPageChange(newPage)

    const obj = new URLSearchParams(window.location.search);
    obj.set('page', newPage)
    // console.log()
    navigate(window.location.pathname + '?' + obj.toString())
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    console.log(rowsPerPage)
    const obj = new URLSearchParams(window.location.search);
    obj.set('page-size', event.target.value)
    console.log(obj.toString())
    navigate(window.location.pathname + '?' + obj.toString())
    onRowsPerPageChange(event)

    setPage(0);
  };

  return (<div className='flex items-center justify-end'>
    <TablePagination
      component="div"
      count={total}
      page={page-1}
      onPageChange={handleChangePage}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      rowsPerPageOptions={[5, 10, 15, 20, 25]}
      backIconButtonProps={{className:'hidden'}}
      nextIconButtonProps={{className:'hidden'}}
    />
    <Pagination count={Math.round(total / rowsPerPage, 1)} page={page} onChange={handleChangePage} showFirstButton showLastButton />
  </div>
  )
}
